import { Box, IconButton, TextField, Typography } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { isBrowser } from "react-device-detect";
import { icon, isNullOrEmpty, WEBSITE_PATH } from "../common/common";
import CreateMenu from "./menu";
import { forwardRef, useImperativeHandle, useState } from "react";

interface HeaderProps {
  title: string;
  isTextBox: boolean;
  onChange?: any;
  searchText?: string;
  onCloseClck?: any;
  noBack?: boolean;
  onlyText?: boolean;
}

export const CreateHeader = ({ title, isTextBox, onChange, searchText, onCloseClck, noBack, onlyText }: HeaderProps) => {
  const navigate = useNavigate();
  return (
    <Box className="inboxHeaderContainer mdc-typography--border-bottom">
      {noBack !== false ? (
        <IconButton
          className="icon-primary"
          onClick={() => {
            navigate(-1);
          }}
        >
          {icon({ iconName: "arrow_back" })}
        </IconButton>
      ) : (
        ""
      )}

      {!isTextBox ? (
        <Box className="flex-center" sx={{ width: onlyText ? "100%" : "calc(100% - 96px)" }}>
          <Typography className="inboxHeaderTitle text-primary" variant="h6">
            {title}
          </Typography>
        </Box>
      ) : (
        <Box className="flex-center mar-l-8" sx={{ width: "100%" }}>
          <TextField
            className="searchTextField"
            variant="filled"
            fullWidth
            color="primary"
            placeholder={title}
            size="small"
            value={searchText}
            inputProps={{
              maxLength: 41,
            }}
            onChange={onChange}
            InputProps={{
              startAdornment: icon({ iconName: "search", iconColor: "icon-secondary" }),
              endAdornment: searchText !== "" && (
                <IconButton className="text-primary mar-l-8" sx={{ height: 40 }} onClick={onCloseClck}>
                  {icon({ iconName: "close", iconColor: "icon-secondary", iconSize: `${isBrowser ? "size-24" : "size-16"}` })}
                </IconButton>
              ),
            }}
          />
        </Box>
      )}
    </Box>
  );
};

interface HeaderInboxProps {
  isNewChat: boolean;
  connectivityStatus: boolean;
  userId?: string;
  sessionId?: string;
}

export const CreateHeaderInbox = ({ isNewChat, connectivityStatus, userId, sessionId }: HeaderInboxProps) => {
  const navigate = useNavigate();
  const OnNewChatClick = () => {
    navigate(`/chats?userId=${userId}&sessionId=${sessionId}`);
  };

  const OnSearchClick = () => {
    navigate(`/search?userId=${userId}&sessionId=${sessionId}&query=`);
  };

  return (
    <Box className="inboxHeaderContainer mdc-typography--border-bottom">
      <IconButton disabled={!isNewChat} className={!isNewChat ? "cur-pot-none" : ""} onClick={OnNewChatClick}>
        {icon({ iconName: "add_circle_outline", iconColor: `${!isNewChat ? "icon-quick-silver cur-pot-none" : ""}` })}
      </IconButton>
      <Box className="flex-1 flex-center">
        <Box className="flex-row flex-center">
          <Typography variant="h6" className="text-primary clsInboxHeaderTitle">
            Inbox
          </Typography>
          <Box
            className="headerConnectivityContainer flex-center flex-row mdc-typography--border mar-l-8 cur-pot"
            sx={{ height: "32px", borderRadius: "16px" }}
            onClick={() => {
              window.parent.postMessage({ message: connectivityStatus, type: "onlinepopup" }, WEBSITE_PATH);
            }}
          >
            <Box className={`bor-rad-50 ${connectivityStatus ? "bg-vibrant-green" : "bg-secondary"}`} sx={{ width: "12px", height: "12px", marginLeft: "6px" }}></Box>
            {icon({ iconName: "keyboard_arrow_down", iconStyle: { marginLeft: "6px", marginRight: "4px" } })}
          </Box>
        </Box>
      </Box>

      <IconButton onClick={OnSearchClick}>{icon({ iconName: "search" })}</IconButton>
    </Box>
  );
};

interface menuHeaderProps {
  backCallback?: any;
  arrMenuOptions: any;
  dataCount: number;
}

const CreateMenuHeader = ({ backCallback, arrMenuOptions, dataCount }: menuHeaderProps, ref?: any) => {
  const [messageAnchorElement, setMessageAnchorElement] = useState<any>(null);
  useImperativeHandle(ref, () => ({
    hideMenu: () => {
      setMessageAnchorElement(null);
    },
  }));
  return (
    <Box className="inboxHeaderContainer flex-space-between mdc-typography--border-bottom">
      <Box className=" flex align-items-center">
        <IconButton
          className="icon-primary"
          onClick={() => {
            backCallback && backCallback();
          }}
        >
          {icon({ iconName: "arrow_back" })}
        </IconButton>
        <Typography variant="h6" className="ft-18 text-primary" sx={{ padding: "0 16px" }}>
          {dataCount}
        </Typography>
      </Box>
      <Box className="flex" sx={{ gap: "8px" }}>
        {arrMenuOptions &&
          arrMenuOptions.length > 0 &&
          arrMenuOptions.map((v: any, i: number) => (
            <Box key={i}>
              <IconButton
                className="icon-primary"
                onClick={(e) => {
                  v.callback && v.callback();
                  if (!isNullOrEmpty(v.menuOnClick)) {
                    setMessageAnchorElement({
                      index: i,
                      target: e.currentTarget,
                    });
                  }
                }}
              >
                {v.icon}
              </IconButton>
              {messageAnchorElement && !isNullOrEmpty(v.menuOnClick) && (
                <CreateMenu
                  anchorElement={messageAnchorElement.target}
                  setAnchorElement={setMessageAnchorElement}
                  menuItemList={v.menuOnClick}
                  ref={ref}
                  onClose={() => {
                    setMessageAnchorElement("");
                  }}
                />
              )}
            </Box>
          ))}
      </Box>
    </Box>
  );
};

export default forwardRef(CreateMenuHeader);
